// =============================================================================
// SevricMark — the SEVRIC hexagonal monogram, used as the AI's profile photo.
// Source SVG: /brand/sevric/svg/sevric-mark-color-light.svg.
//
// Usage:
//   <SevricMark size={32} />
//   <SevricMark size={44} withGlow />
//
// The mark scales perfectly via the 240×240 viewBox. We bump stroke-width
// to 14 so the outer hex stays visible even at small avatar sizes.
// =============================================================================
import React from "react";

export function SevricMark({ size = 32, color = "#2E5694", className = "", withGlow = false }) {
  const filter = withGlow ? "drop-shadow(0 2px 6px rgba(46,86,148,0.30))" : "drop-shadow(0 1px 3px rgba(46,86,148,0.22))";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 240 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sevric-mark ${className}`.trim()}
      style={{ display: "block", filter }}
      aria-hidden="true"
    >
      <polygon
        points="200,120 160,189.28 80,189.28 40,120 80,50.72 160,50.72"
        fill="none"
        stroke={color}
        strokeWidth="14"
        strokeLinejoin="miter"
      />
      <polygon
        points="156,120 138,151.18 102,151.18 84,120 102,88.82 138,88.82"
        fill={color}
      />
    </svg>
  );
}

// Convenience: SEVRIC AI avatar — mark + green online dot.
export function SevricAiAvatar({ size = 32 }) {
  const dotSize = Math.max(8, Math.round(size * 0.28));
  return (
    <div
      className="sevric-ai-avatar"
      style={{
        width: size, height: size,
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <SevricMark size={size} />
      <span
        aria-label="online"
        style={{
          position: "absolute",
          right: 0, bottom: 0,
          width: dotSize, height: dotSize,
          borderRadius: "50%",
          background: "#2A6D38",
          border: "2px solid var(--bg-elev, #FBFBF9)",
        }}
      />
    </div>
  );
}
